import { jsxs as p, jsx as i } from "react/jsx-runtime";
import c from "react";
import t, { css as e } from "styled-components";
import { _ as N, b as B, a as _, h as z, i as L } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { a as u, R as S } from "../chunks/index.cff5baaf.js";
import { R as P, B as E } from "../chunks/index.b09c00db.js";
const h = t(P).withConfig({
  displayName: "ButtonIcon",
  componentId: "sc-12gxm3e-0"
})(["&::before{display:none;}"]), H = t.div.withConfig({
  displayName: "RangoInputPassword",
  componentId: "sc-12gxm3e-1"
})(["& *{margin:0;padding:0;}width:100%;display:flex;flex-direction:column;gap:var(--spacing-1x);", ""], ({
  disabled: o
}) => o && e(["opacity:var(--opacity-low);pointer-events:none;"])), j = t.label.withConfig({
  displayName: "Label",
  componentId: "sc-12gxm3e-2"
})(["", " color:var(--text-label-color);", " ", " ", ""], N, ({
  clicked: o
}) => o && e(["color:var(--active-label-color);"]), ({
  disabled: o
}) => o && e(["color:var(--disabled-label-color);"]), ({
  error: o
}) => o && e(["color:var(--negative-label-color);"])), O = t.div.withConfig({
  displayName: "Element",
  componentId: "sc-12gxm3e-3"
})(["height:var(--size-8x);width:100%;display:flex;align-items:center;border:var(--default-border-width) solid var(--elements-border-color);border-radius:var(--default-border-radius);box-sizing:border-box;transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);", " ", " ", " ", " ", ""], ({
  clicked: o
}) => !o && e(["&:focus-within:not(:active){", " outline-offset:2px;}"], B), ({
  clicked: o
}) => o && e(["border-color:var(--active-border-color);transition-property:all;transition-timing-function:var(--curve-productive-entrance);transition-duration:var(--duration-fast-02);outline:transparent;"]), ({
  disabled: o
}) => o && e(["border-color:var(--disabled-border-color);"]), ({
  error: o
}) => o && e(["border-color:var(--negative-border-color);& input{padding-right:var(--spacing-1x);}"]), ({
  error: o,
  clicked: r
}) => !o && !r && e(["&:focus-within:not(:active){border-color:var(--active-border-color);}&:hover{", " border-color:transparent;transition-timing-function:var(--curve-productive-entrance);}"], _)), T = t.input.withConfig({
  displayName: "Input",
  componentId: "sc-12gxm3e-4"
})(["", " color:var(--active-placeholder-color);width:100%;outline:none;border:none;box-sizing:border-box;border-radius:inherit;background-color:transparent;padding-left:var(--spacing-2x);padding-right:0px;height:var(--size-8x);&:-webkit-autofill{-webkit-background-clip:text;}", " &:disabled{background-color:transparent;color:var(--disabled-placeholder-color);&::placeholder{color:var(--disabled-placeholder-color);}}&::placeholder{color:var(--text-placeholder-color);}", " ", ""], z, ({
  error: o
}) => !o && e(["&:focus-within:not(:active){color:var(--active-placeholder-color);}"]), ({
  clicked: o,
  error: r
}) => o && !r && e(["color:var(--active-placeholder-color);"]), ({
  error: o
}) => o && e(["color:var(--negative-placeholder-color);&::placeholder{color:var(--negative-placeholder-color);}"])), F = t.div.withConfig({
  displayName: "Icons",
  componentId: "sc-12gxm3e-5"
})(["height:100%;margin-right:var(--size-half);display:flex;align-items:center;", "{background-color:transparent;}", "{color:var(--elements-icon-color);}", " ", ""], h, u, ({
  disabled: o
}) => o && e(["", "{color:var(--disabled-icon-color);}"], u), ({
  error: o
}) => o && e(["", "{color:var(--negative-icon-color);}"], u)), G = t.p.withConfig({
  displayName: "SupportText",
  componentId: "sc-12gxm3e-6"
})(["", " color:var(--text-support-text-color);", " ", ""], L, ({
  disabled: o
}) => o && e(["color:var(--disabled-support-text-color);"]), ({
  error: o
}) => o && e(["color:var(--negative-support-text-color);"])), M = c.forwardRef(({
  id: o = "",
  disabled: r = !1,
  hidden: a = !1,
  error: n = !1,
  label: x = "",
  placeholder: b = "",
  supportText: v = "",
  buttonIconAriaLabel: w,
  inputProps: $,
  ...I
}, y) => {
  const R = c.useRef(), [l, g] = c.useState(a), [s, f] = c.useState(!1), d = c.useRef(a);
  c.useEffect(() => {
    a !== d.current && (g(a), d.current = a);
  }, [a, d.current]);
  const k = () => {
    f(!0);
  }, C = () => {
    g(!l);
  }, m = () => {
    f(!1);
  };
  return /* @__PURE__ */ p(H, { disabled: r, ref: y, "data-rango-component": "rango-input-password", "data-is-rango": !0, children: [
    /* @__PURE__ */ i(j, { clicked: s, disabled: r, error: n && !r, htmlFor: o, children: x }),
    /* @__PURE__ */ p(O, { disabled: r, error: n && !r, clicked: s, onClick: k, children: [
      /* @__PURE__ */ i(T, { type: l ? "password" : "text", id: o, ref: R, ...I, placeholder: b, clicked: s, disabled: r, error: n && !r, onBlur: m }),
      /* @__PURE__ */ p(F, { disabled: r, error: n && !r, children: [
        n && !r && /* @__PURE__ */ i(S, { icon: "NegativeLine" }),
        /* @__PURE__ */ i(h, { ariaLabel: w, disabled: r, size: E.LG, icon: l ? "HideOffLine" : "HideLine", onClick: C, onBlur: m })
      ] })
    ] }),
    v && /* @__PURE__ */ i(G, { disabled: r, error: n && !r, children: v })
  ] });
});
M.displayName = "RangoInputPassword";
export {
  M as RangoInputPassword
};
